import(/* webpackMode: "eager" */ "/home/runner/work/next-embed-player/next-embed-player/src/app/not-found.js");
